import Vue from 'vue';

window.axios = require('axios');
// import MainNavigation from './components/Main-Navigation.vue';
// import ContactPopup from './components/Contact-Popup.vue';
// import Stephan from "./components/Stephan";


window.EventBus = new Vue();

Vue.component('main-navigation', require('./components/MainNavigation.vue').default);
Vue.component('contact-popup', require('./components/ContactPopup.vue').default);
Vue.component('employee-popup', require('./components/EmployeePopup.vue').default);
Vue.component('accordion', require('./components/Accordion.vue').default);

if (document.getElementById('app') !== null) {
    const app = new Vue({
        el: '#app',
        methods: {
            openModal: function(event) {
                event.preventDefault();
                let formtype = event.target.dataset['type'];
                EventBus.$emit('open-contact-modal', formtype);
            },
            // openContactModal: function(){
            //     EventBus.$emit('open-employee-modal');
            // }
        }
    });
}

window.scrollToCountrySection = function() {
    let countrylist = document.getElementById('countrylist');
    window.scrollTo({
        top: countrylist.offsetTop - 12,
        behavior: 'smooth'
    });
};


var acc = document.getElementsByClassName("accordion");
var i;

for(i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    });
}

window.openHomeTab = function(panel) {
    let panels        = document.getElementsByClassName('js-home-content-tab');
    let tabNavigation = document.getElementById('js-home-tabs');

    let i;
    for(i = 0; i < panels.length; i++) {
        panels[i].style.display = 'none';
    }
    let target           = document.getElementById('js-hometab-' + panel);
    target.style.display = 'block';
    window.scrollTo({
        top: tabNavigation.offsetTop - 12,
        behavior: 'smooth'
    });

    let tabs = document.getElementsByClassName('js-home-button-indicator');

    for(i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('border-green-500');
        tabs[i].classList.remove('text-blue-600');
    }
    let button = document.getElementById('js-home-button-' + panel);
    button.classList.add('border-green-500');
    button.classList.add('text-blue-600');
};


function movePillToWorldAnimation() {
    let redPillElement   = document.getElementById("animatePillSVGRed");
    let bluePillElement  = document.getElementById("animatePillSVGBlue");
    let greenPillElement = document.getElementById("animatePillSVGGreen");

    let pillKeyframes    = [{
        opacity: 1,
        transform: "translateX(0)",
    },
        {
            opacity: 0,
            transform: "translateX(80%)",
        },
        {
            opacity: 0,
            transform: "translateX(0)"
        },
        {
            opacity: 1,
            transform: "translateX(0)"
        }
    ];
    let redPillOptions   = {
        duration: 2000,
        easing: 'ease-in-out',
    };
    let bluePillOptions  = {
        duration: 2000,
        easing: 'ease-in-out',
    };
    let greenPillOptions = {
        duration: 2300,
        easing: 'ease-in-out',
    };

    function animateRedPill() {
        redPillElement.animate(pillKeyframes, redPillOptions);
    }

    function animateBluePill() {
        bluePillElement.animate(pillKeyframes, bluePillOptions);
    }

    function animateGreenPill() {
        greenPillElement.animate(pillKeyframes, greenPillOptions);
    }

    setInterval(animateRedPill, 2000);
    setInterval(animateBluePill, 1500);
    setInterval(animateGreenPill, 3000);

}

document.addEventListener("DOMContentLoaded", function() {
    const twinpharmaMap      = document.querySelectorAll(".js-twinpharma-map-area");
    const exceedOrphanMap    = document.querySelectorAll(".js-exceed-orphan-map-area");
    const frostpharmaMap     = document.querySelectorAll(".js-frostpharma-map-area");

    for(var i = 0; i < twinpharmaMap.length; i++) {
        const currentElement      = twinpharmaMap[i];
        const twinpharmaMapEls    = document.querySelectorAll(".js-twinpharma-map-area");
        const twinpharmaMapMarker = document.querySelector(".js-twinpharma-map-marker");

        currentElement.addEventListener("mouseover", (event) => {
            for(var i = 0; i < twinpharmaMapEls.length; i++) {
                twinpharmaMapEls[i].classList.remove('opacity-75');
                twinpharmaMapEls[i].classList.add('opacity-100');
            }
            if (window.innerWidth >= 1200) {
                twinpharmaMapMarker.classList.remove('hidden');
                twinpharmaMapMarker.classList.add('inline-block');
            }
        });

        currentElement.addEventListener("mouseleave", (event) => {
            for(var i = 0; i < twinpharmaMapEls.length; i++) {
                twinpharmaMapEls[i].classList.remove('opacity-100');
                twinpharmaMapEls[i].classList.add('opacity-75');
            }
            if (window.innerWidth >= 1200) {
                twinpharmaMapMarker.classList.remove('inline-block');
                twinpharmaMapMarker.classList.add('hidden');
            }
        });
        currentElement.addEventListener("click", (event) => {
            location.href = '/benelux';
        });
    }

    for(var i = 0; i < exceedOrphanMap.length; i++) {
        const currentElement        = exceedOrphanMap[i];
        const exceedOrphanMapEls    = document.querySelectorAll(".js-exceed-orphan-map-area");
        const exceedOrphanMapMarker = document.querySelector(".js-exceed-orphan-map-marker");

        currentElement.addEventListener("mouseover", (event) => {
            for(var i = 0; i < exceedOrphanMapEls.length; i++) {
                exceedOrphanMapEls[i].classList.remove('opacity-75');
                exceedOrphanMapEls[i].classList.add('opacity-100');
            }
            if (window.innerWidth >= 1200) {
                exceedOrphanMapMarker.classList.remove('hidden');
                exceedOrphanMapMarker.classList.add('inline-block');
            }

        });

        currentElement.addEventListener("mouseleave", (event) => {
            for(var i = 0; i < exceedOrphanMapEls.length; i++) {
                exceedOrphanMapEls[i].classList.remove('opacity-100');
                exceedOrphanMapEls[i].classList.add('opacity-75');
            }
            if (window.innerWidth >= 1200) {
                exceedOrphanMapMarker.classList.remove('inline-block');
                exceedOrphanMapMarker.classList.add('hidden');
            }
        });
        currentElement.addEventListener("click", (event) => {
            location.href = '/central-eastern-europe';
        });
    }

    for(var i = 0; i < frostpharmaMap.length; i++) {
        const currentElement       = frostpharmaMap[i];
        const frostpharmaMapEls    = document.querySelectorAll(".js-frostpharma-map-area");
        const frostpharmaMapMarker = document.querySelector(".js-frostpharma-map-marker");

        currentElement.addEventListener("mouseover", (event) => {
            for(var i = 0; i < frostpharmaMapEls.length; i++) {
                frostpharmaMapEls[i].classList.remove('opacity-75');
                frostpharmaMapEls[i].classList.add('opacity-100');
            }
            if (window.innerWidth >= 1200) {
                frostpharmaMapMarker.classList.remove('hidden');
                frostpharmaMapMarker.classList.add('inline-block');
            }
        });

        currentElement.addEventListener("mouseleave", (event) => {
            for(var i = 0; i < frostpharmaMapEls.length; i++) {
                frostpharmaMapEls[i].classList.remove('opacity-100');
                frostpharmaMapEls[i].classList.add('opacity-75');
            }
            if (window.innerWidth >= 1200) {
                frostpharmaMapMarker.classList.remove('inline-block');
                frostpharmaMapMarker.classList.add('hidden');
            }
        });
        currentElement.addEventListener("click", (event) => {
            location.href = '/scandinavia';
        });
    }

    if (document.getElementById('WorldAnimationJS') !== null) {
        movePillToWorldAnimation();
    }
});


